window.initInputStyles = function() {
    const initInput = (input) => {
        const handler = () => {
            input.classList.toggle('filled', input.value !== '');
        };

        if (!input._inputStyleInitialized) {
            input.addEventListener('input', handler);
            input.addEventListener('focus', handler);
            input._inputStyleInitialized = true;
            handler();
        }
    };

    const initMasks = (input) => {
        if (input.type === 'tel' && !input._maskInitialized) {
            // Инициализация маски для телефона
            input.addEventListener('input', function(e) {
                // Базовая маска для российского номера
                let value = e.target.value.replace(/\D/g, '');

                if (value.startsWith('7') || value.startsWith('8')) {
                    value = value.substring(1);
                }

                let formattedValue = '+7 ';

                if (value.length > 0) {
                    formattedValue += value.substring(0, 3);
                }
                if (value.length > 3) {
                    formattedValue += ' ' + value.substring(3, 6);
                }
                if (value.length > 6) {
                    formattedValue += ' ' + value.substring(6, 8);
                }
                if (value.length > 8) {
                    formattedValue += ' ' + value.substring(8, 10);
                }

                e.target.value = formattedValue;
            });

            input._maskInitialized = true;
        }
    };

    const initPolicyCheckbox = (checkboxWrapper) => {
        if (!checkboxWrapper._policyCheckboxInitialized &&
            checkboxWrapper.classList.contains('checkbox-policy')) {

            const checkboxInput = checkboxWrapper.querySelector('.checkbox-toggle-input');

            if (checkboxInput) {
                checkboxInput.addEventListener('change', function() {
                    // Если чекбокс в состоянии ошибки и пользователь меняет его состояние
                    // удаляем класс error
                    if (checkboxWrapper.classList.contains('error')) {
                        checkboxWrapper.classList.remove('error');
                    }
                });
            }

            checkboxWrapper._policyCheckboxInitialized = true;
        }
    };

    // Инициализация для существующих элементов
    document.querySelectorAll('.input-field').forEach(input => {
        initInput(input);
        initMasks(input);
    });

    // Инициализация чекбоксов политики
    document.querySelectorAll('.checkbox-policy').forEach(checkbox => {
        initPolicyCheckbox(checkbox);
    });

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) {
                    // Для отдельных инпутов
                    if (node.classList && node.classList.contains('input-field')) {
                        initInput(node);
                        initMasks(node);
                    }
                    // Для контейнеров с инпутами
                    if (node.querySelectorAll) {
                        node.querySelectorAll('.input-field').forEach(input => {
                            initInput(input);
                            initMasks(input);
                        });

                        node.querySelectorAll('.checkbox-policy').forEach(checkbox => {
                            initPolicyCheckbox(checkbox);
                        });
                    }
                    // Если сам нод - это checkbox-policy
                    if (node.classList && node.classList.contains('checkbox-policy')) {
                        initPolicyCheckbox(node);
                    }
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

window.updateInputStyles = function() {
    document.querySelectorAll('.input-field').forEach(input => {
        // Обновляем состояние filled
        input.classList.toggle('filled', input.value !== '');

        // Если это телефон, форматируем значение
        if (input.type === 'tel' && input.value) {
            let value = input.value.replace(/\D/g, '');
            if (value.startsWith('7') || value.startsWith('8')) {
                value = value.substring(1);
            }
            let formattedValue = '+7 ';
            if (value.length > 0) formattedValue += value.substring(0, 3);
            if (value.length > 3) formattedValue += ' ' + value.substring(3, 6);
            if (value.length > 6) formattedValue += ' ' + value.substring(6, 8);
            if (value.length > 8) formattedValue += ' ' + value.substring(8, 10);
            input.value = formattedValue;
        }
    });
};

window.updateInputStyles = function() {
    if (typeof $ !== 'undefined' && $.fn.niceSelect) {
        $('select').niceSelect({
            animationSpeed: 0
        });
    }
};